import script from "./WordPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./WordPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__